module.exports = __webpack_public_path__ + "static/img/Matt_Crouch_mobile.48bfabc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt_Crouch_mobile.jpg
// module id = u4e8
// module chunks = 0